import React from 'react';
import {Styles} from '../../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import TextField from "@material-ui/core/TextField/TextField";
import axios from "axios";
import {defaultVariabls} from "../../../../../config/index";
import {withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import {setStore} from "trim-redux";
import Autocomplete from "@material-ui/lab/Autocomplete/Autocomplete";
import {FieldSkeleton} from "../../../../components/Skeletons/FieldSkeleton";
import {Translate} from "../../../../../config/Translate";


class ChooseCommentReplay extends React.Component {
    state = {
        comments: null,
        loading:true,
        output:null,
        input:null,
        defaults: null,
        product_id: null,
    };
    classes = this.props.classes;
    async componentDidMount(){
        await this.setState({
            product_id: this.props.product_id,
            input: this.props.inPut

        })
        await this.loadData()
    }

    async loadData(){
        let loginToken = localStorage.getItem('ACT');
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            let data = new FormData();
            data.append('product_id', this.props.product_id ? this.props.product_id : 0);
            await axios.post(`${defaultVariabls.url}/comments/getForReplay`,data, config)
                .then(response => {
                    this.setState({
                        comments: response.data,
                    })
                    this.loadDefault();

                })
                .catch(error => {
                    this.setState({
                        loading:false
                    })
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
                loading:false
            });
            this.setState({
                loading:false
            })
        }
    }
    async loadDefault(){
        let {input,comments} = this.state;
        if(input > 0){
            if(comments !== null){
                await comments.map(row =>{
                    if(row.id === input){
                        this.setState({
                            defaults:row,
                            output:row,
                            loading:false
                        })
                        this.props.outPut(row);

                    }
                    return true
                })
            }
        }else{
            this.setState({
                loading:false
            })
        }

    }
    handChange(value){
        this.setState({
            output:value,
        })
        this.props.outPut(value);
    }

    render(){
        let {comments,defaults,input} = this.state;
        return (
            <React.Fragment>
                {
                    this.state.loading ?
                        <FieldSkeleton/>
                        :
                        !!comments !== undefined ?
                            <Autocomplete
                                options={comments}
                                className="autoCompleteHolder"
                                defaultValue={defaults}

                                onChange={(event, value) => this.handChange(value)}
                                getOptionLabel={option => "("+option.name+") "+option.comment.slice(0,15)+"..."}
                                renderInput={params => (
                                    <TextField
                                        {...params}
                                        label={Translate.comments}
                                        variant="outlined"
                                        fullWidth
                                        helperText={Translate.commentForReplayDescription}

                                    />
                                )}
                            /> :
                            Translate.noProduct
                }
            </React.Fragment>

        );
    }
}

export default withSnackbar(withRouter(withStyles(Styles)(ChooseCommentReplay)));